import { numberToABC } from '@doltech/utils/lib/text';
import { range } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ReadingTestSectionInstance } from '../../../question-data-model/TestSection/_implementations/reading-test-section.store';
import { DoTestMatchingHeadingQuestionInstance } from '../../../student-do-test/model/Question/do-test-matching-heading-question.store';
import { CircleTextType, ViewTestMatching } from './ViewTestMatching';

export interface MatchingHeadingAnswerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestMatchingHeadingQuestionInstance;
  currentSection?: ReadingTestSectionInstance;
}

export const ViewTestMatchingHeading = observer((props: MatchingHeadingAnswerProps) => {
  const { data, currentSection, ...rest } = props;
  const { no, options, paragraphKeys } = data;

  const questionOptions = range(currentSection.paragraphCount)
    .map((paragraphIndex) => {
      const label = numberToABC(paragraphIndex + 1);

      return {
        key: paragraphIndex,
        value: `Paragraph ${label}`,
      };
    })
    .filter((o) => paragraphKeys.includes(o.key));

  return (
    <ViewTestMatching
      currentQuestionNo={no}
      title="List of Headings"
      questionOptions={questionOptions}
      findingOptions={options}
      findingOptionCircleTextType={CircleTextType.ROMAN}
      questionOptionCircleTextType={CircleTextType.NUMBER}
      {...rest}
    />
  );
});
